import { AJOUTE_URL_SOCIETE, SUPRIMER_URL_SOCIETE } from '../types/typeUrlSociete';

export const AjouteUrlSociete = (societe) => {
    return {
        type: AJOUTE_URL_SOCIETE,
        payload: societe
    }
}

export const suprimerUrlSociete = (societe) => {
    return {
        type: SUPRIMER_URL_SOCIETE,
        payload: societe
    }
}